import { EMPLOYMENT_VALUES } from '../../../../constants/sources';
import { EMPLOYMENT_TYPE_DEPS } from '../../../../constants/field.dependencies';

export const needed = (field: FE.FieldName, employmentType: string) => {
    const dependencies =
        EMPLOYMENT_TYPE_DEPS[employmentType as ValuesOf<typeof EMPLOYMENT_VALUES>] ||
        EMPLOYMENT_TYPE_DEPS[EMPLOYMENT_VALUES.EMPLOYMENT];
    return dependencies.includes(field);
};
